module.exports = __webpack_public_path__ + "static/media/sliderArrowRight.48b7070a.svg";